export default __webpack_public_path__ + "static/media/higher_brand_arrow_margin.2a552a3d.svg";